import type { NavigationItem } from '@/types/layout.types';
import HomeIcon from '@/assets/icons/main-bottom-navigation/home.svg?react';
import EventsIcon from '@/assets/icons/main-bottom-navigation/events.svg?react';
import LeaderboardIcon from '@/assets/icons/main-bottom-navigation/leaderboard.svg?react';
import ProfileIcon from '@/assets/icons/main-bottom-navigation/profile.svg?react';

export const MOBILE_BOTTOM_NAV_ICONS: Record<string, NavigationItem['icon']> = {
	Home: HomeIcon,
	Events: EventsIcon,
	Leaderboard: LeaderboardIcon,
	Profile: ProfileIcon,
};

export const NO_LAYOUT_PAGES = [
	'Auth',
	'ProfileSetup',
	'ParentEmailVerification',
	'ParentalConsent',
	'ExternalLeaderboard',
];

export const PAGES_WITHOUT_NAV = [
	'EditProfile',
	'MarketPerformance',
	'Auth',
	'refer',
	'ProfileSetup',
	'ParentEmailVerification',
	'ParentalConsent',
	'ExternalLeaderboard',
];

/** Legacy short URLs shared externally before /sponsor/:slug existed. */
export const LEGACY_SPONSOR_SLUGS = [
	'2025challenge',
	'ambipredicts',
	'asiapickleballinsider',
	'boxboxbox',
	'butterspklspringseason2026paldohan',
	'butterspredictkic2025',
	'champzero',
	'chippuday',
	'couchcrew',
	'davidlombardi',
	'eagle',
	'explicitesports',
	'houseofstrauss',
	'iheartmedia',
	'kenofficialm7predictions',
	'mingmongtvkis4predictions',
	'monzabarcade',
	'mplseason17xkenofficial',
	'professorjoseph',
	'publiclobby',
	'senbenedetta',
	'seyrahkicprediction',
	'seyrahm7lobby',
	'shikigami',
	'sportstalk790',
	'tosspizzeria',
	'twishpkl2026',
	'yo1phhokpredictions',
	'yugingaming',
];
